module.exports = __webpack_public_path__ + "img/get.1b659262.svg";